export interface Notification {
  id: number;
  type: NotificationType;
  content: NotificationContent;
  isRead: boolean;
  createdAt: string;
  isImportant: boolean;
}

export type NotificationContent = SuccessDepositContent |
                      ItemSentContent |
                      ItemNotAvailableContent |
                      ItemUnlockedContent |
                      InvalidTradeLinkContent |
                      InventoryPrivateContent |
                      TicketChangeContent |
                      ChatBanContent |
                      TextContent |
                      NewLevelContent |
                      QuestCompletedContent |
                      WagerFailedContent |
                      WagerDoneContent |
                      TaskBonusContent;

export interface TaskBonusContent {
  amountUsd: number;
  name: string;
}

export interface SuccessDepositContent {
  amountUsd: number;
}

export interface ItemSentContent {
  marketName: string;
  priceUsd: number;
  tradeId: string;
}

export interface ItemNotAvailableContent {
  marketName: string;
}

export interface ItemUnlockedContent {
  marketName: string;
}

export interface InvalidTradeLinkContent {
}

export interface InventoryPrivateContent {
}

export interface TicketChangeContent {
  ticketId: number;
}

export interface ChatBanContent {
  reason: string;
}

export interface TextContent {
  text: string;
}

export interface NewLevelContent {
  prevLvl: number;
  newLvl: number;
}

export interface QuestCompletedContent {
  title: string;
  goal: number;
}

export type WagerFailedContent = null;

export type WagerDoneContent = {
  bonus: number;
};

export enum NotificationType {
  SUCCESS_DEPOSIT = 1,
  ITEM_SENT = 2,
  ITEM_NOT_AVAILABLE = 3,
  ITEM_UNLOCKED = 4,
  INVALID_TRADE_LINK = 5,
  INVENTORY_PRIVATE = 6,
  TICKET_CHANGE = 7,
  CHAT_BAN = 8,
  CUSTOM = 9,
  LIMITED_TRADE_POSSIBILITY = 10,
  ITEMS_RAIN = 11,
  LEADERS = 12,
  NEW_LEVEL = 13,
  QUEST_COMPLETED = 14,
  CRASH_BONUS_GAME_PRIZE = 15,
  DOUBLE_JACKPOT = 16,
  WAGER_DONE = 17,
  WAGER_FAILED = 18,
  TASK_BONUS = 19,
  RAFFLE_WIN = 20
}

export const NOTIFICATION_TITLE: Record<NotificationType, string> = {
  [NotificationType.CHAT_BAN]: $localize`:@@notifications.chat_ban.title:Вы заблокированы в чате`,
  [NotificationType.CRASH_BONUS_GAME_PRIZE]: $localize`:@@notifications.crash_bonus_game_prize.title:Бонусная игра Crash`,
  [NotificationType.CUSTOM]: $localize`:@@notifications.custom.title:Сообщение от администрации`,
  [NotificationType.INVALID_TRADE_LINK]: $localize`:@@notifications.invalid_trade_link.title:Ссылка на обмен не работает`,
  [NotificationType.INVENTORY_PRIVATE]: $localize`:@@notifications.inventory_private.title:Ваш инвентарь скрыт`,
  [NotificationType.ITEMS_RAIN]: $localize`:@@notifications.items_rain.title:Скинопад`,
  [NotificationType.ITEM_NOT_AVAILABLE]: $localize`:@@notifications.item_not_available.title:Предмет не отправлен`,
  [NotificationType.ITEM_SENT]: $localize`:@@notifications.item_sent.title:Предмет отправлен`,
  [NotificationType.ITEM_UNLOCKED]: $localize`:@@notifications.item_unlocked.title:Предмет доступен к переотправке`,
  [NotificationType.LEADERS]: $localize`:@@notifications.leaders.title:Топ игроков`,
  [NotificationType.LIMITED_TRADE_POSSIBILITY]: $localize`:@@notifications.limited_trade_possibility.title:Вы не можете обмениваться`,
  [NotificationType.NEW_LEVEL]: $localize`:@@notifications.new_level.title:Новый уровень`,
  [NotificationType.QUEST_COMPLETED]: $localize`:@@notifications.quest_completed.title:Квест завершен`,
  [NotificationType.SUCCESS_DEPOSIT]: $localize`:@@notifications.success_deposit.title:Успешное пополнение`,
  [NotificationType.TICKET_CHANGE]: $localize`:@@notifications.ticket_change.title:Ответ в поддержке`,
  [NotificationType.DOUBLE_JACKPOT]: $localize`:@@notifications.double_jackpot.title:Выгрыш в Double Jackpot`,
  [NotificationType.WAGER_DONE]: $localize`:@@notifications.wager_done.title:Бонус отыгран`,
  [NotificationType.WAGER_FAILED]: $localize`:@@notifications.wager_failed.title:Бонус не отыгран`,
  [NotificationType.TASK_BONUS]: $localize`:@@notifications.task_bonus.title:Бонус за подписку`,
  [NotificationType.RAFFLE_WIN]: $localize`:@@notifications.raffle_win.title:Выигрыш в розыгрыше`
};

export namespace ApiResponse {
  export interface Notifications {
    notifications: Notification[];
  }
}